import * as yup from 'yup'
export const editCustomerRequestSchema = yup.object().shape({
    vendor_id: yup
        .string()
        .required('اختر النشاط التجارى الذى سوف يتم توجيه اليه'),
})
